import { z } from 'zod';

/**
 * Reading of the owner's plan-review comment. Passed to the model as a structured-output
 * contract, so the answer is either an approval or a list of requested changes.
 */
export const PipelinePlanReviewSchema = z.object({
  approved: z
    .boolean()
    .describe(
      'True when the owner accepts the plan as it stands, for example "Agreed to all decision points" or "Go ahead". False when the owner asks for any change, rejects a decision point, or asks a question.',
    ),
  changes: z
    .array(z.string())
    .describe(
      'Each change the owner asked for, one entry per change, quoting the decision point label (D1, D2) when the owner used one. Empty when approved.',
    ),
});

export type PipelinePlanReviewResult = z.infer<typeof PipelinePlanReviewSchema>;
